<!-- 应用市场 -->
<template>
  <div class="market">
    <div class="marketBar">
      <div class="soo width">
        <div class="sooTitle">
          <h2>应用市场</h2>
          <span>助力企业提质增效，重塑企业核心竞争力</span>
        </div>
        <div class="sooInput">
          <el-input placeholder="请输入内容" v-model="input">
            <el-button type="primary" slot="append" icon="el-icon-search" @click="bb(input)"></el-button>
          </el-input>
        </div>
        <div class="aLink">
          <el-button type="primary">定制需求</el-button>
        </div>
      </div>
      <div class="marketNav">
        <div class="marketContent width">
          <div class="marketBg" @mouseleave="show=false">
            <img class="img1" src="../assets/images/u10.png" alt srcset />
            <img class="img2" src="../assets/images/u29.svg" alt srcset />
            <img class="img3" src="../assets/images/u30.svg" alt srcset />
            <div class="marTitle">
              <div
                class="marspan"
                v-for="(item,i) in barTitle"
                :key="i"
                @mouseover="showTwo(item.id)"
              >{{item.name}}</div>
            </div>
            <div class="marCon boxshadow" v-show="show">
              <div
                class="marLink"
                v-for="(item,i) in twoData"
                :key="i"
                @click="caa(item.id)"
              >{{item.name}}</div>
            </div>
          </div>
          <div class="marLun">
            <!-- 轮播图 -->
            <el-carousel trigger="click" height="400px">
              <el-carousel-item v-for="(item,i) in bannerImg" :key="i">
                <img :src="item.file_url" alt srcset />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <!-- 热门应用 -->
    <div class="hot">
      <h3 class="h3">热门应用</h3>
      <div class="hotCon width" v-if="hotData.length>3">
        <template v-for="(item,i) in hotData">
          <div class="hotConItem itemss" :key="i" v-if="i<1">
            <template v-for="(item,i) in hotData">
              <div class="TwoItem" :key="i" v-if="i<2" @click="bbb(item.id)">
                <div class="imgTwo">
                  <img :src="item.cover_photo" alt srcset />
                </div>
                <div class="textTwo">
                  <h4>{{item.name}}</h4>
                  <p>{{item.introduction}}</p>
                  <p class="aa">
                    <span class="a">￥{{item.price}}/年</span>
                    <!-- <span class="b">{{item.use_count}}家企业在用</span> -->
                  </p>
                </div>
              </div>
            </template>
          </div>
        </template>
        <template v-for="(item,i) in hotData">
          <div class="hotConItem" :key="i" v-if="i>=2" @click="bbb(item.id)">
            <div class="oneItem">
              <h4>{{item.name}}</h4>
              <p class="bb">{{item.introduction}}</p>
              <p class="aa">
                <span class="a">￥{{item.price}}/年</span>
                <!-- <span class="b">{{item.use_count}}家企业在用</span> -->
              </p>
              <div class="imgTwo">
                <img :src="item.cover_photo" alt srcset />
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="hotCon width" v-else>
        <div class="hotConItem" v-for="(item,i) in hotData" :key="i">
          <div class="oneItem">
            <h4>{{item.name}}</h4>
            <p class="bb">{{item.introduction}}</p>
            <p class="aa">
              <span class="a">￥{{item.price}}/年</span>
              <!-- <span class="b">{{item.use_count}}家企业在用</span> -->
            </p>
            <div class="imgTwo">
              <img :src="item.cover_photo" alt srcset />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用分类 -->
    <div class="classify">
      <h3 class="h3">应用分类</h3>
      <div class="classifyCon width">
        <div class="classifyItem" v-for="(item,i) in Classify" :key="i">
          <div class="classifyItem-nav">
            <div class="h4">{{item.name}}</div>
            <div class="ulist">
              <div
                class="ulist-name"
                v-for="(item1,i1) in item.children"
                :key="i1"
                :index="indexId"
                @click="getApp(item1.id,i)"
              >{{item1.name}}</div>
            </div>
            <el-link @click="aaa(item.id)">
              查看更多
              <i class="el-icon-view el-icon-d-arrow-right"></i>
            </el-link>
          </div>
          <div class="classifyItem-list">
            <div class="listItem" v-for="(item1,i1) in item.children[0].children" :key="i1">
              <div class="title">{{item1.name}}({{item1.editionname}})</div>
              <p>{{item1.introduction}}</p>
              <strong>￥{{item1.price}} /{{item1.mtype}}</strong>
              <div class="span">
                <!-- <span>{{item1.use_count}}</span>家企业在用 -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部流程 -->
    <div class="footerList">
      <img src="../assets/images/u218.png" alt srcset />
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { Footer },
  props: {},
  data() {
    return {
      hotData: [],
      bannerImg: [],
      twoData: [],
      input: '',
      barTitle: [],
      Classify: [],
      ClassifyData: [],
      show: false,
      clickShow: true,
      indexId: 11,
      paramsData: {
        names: '',
        ids: 0,
        items: 0,
      },
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getmarketBar()
    this.getBgImage()
    this.getHot()
    this.getClassify()
  },
  mounted() {},
  methods: {
    // 一级导航
    async getmarketBar() {
      const res = await this.$http.post('/getAllapptype')
      this.barTitle = res.data.data
    },
    // 轮播图
    async getBgImage() {
      const res = await this.$http.post('/getbanner', { types: 2 })
      this.bannerImg = res.data.data
    },
    // 二级导航
    async showTwo(i) {
      this.paramsData.ids = i
      const res = await this.$http.post('/getAllSubordinateTypes', { ids: i })
      this.twoData = res.data.data
      this.show = true
    },
    gotoDetailss(i) {},
    // 热门应用
    async getHot() {
      const res = await this.$http.post('/getHotappliction')
      this.hotData = res.data.data
    },
    // 应用分类
    async getClassify() {
      const res = await this.$http.post('/getApptypes')
      this.Classify = res.data.data
    },
    // 根据点击获取应用分类数据
    async getApp(i, j) {
      this.clickShow = false
      this.indexId = i
      const res = await this.$http.post('/getAPPs', { ids: i })
      this.ClassifyData = res.data.data
      // console.log(this.Classify)
      this.Classify[j].children[0].children = this.ClassifyData
      this.paramsData.items = i
    },
    async aaa(i) {
      this.paramsData.ids = i
      this.$router.push({
        name: 'applist',
        params: {
          //params 传递参数
          paramsData: this.paramsData,
        },
      })
    },
    async caa(i) {
      this.paramsData.items = i
      this.$router.push({
        name: 'applist',
        params: {
          //params 传递参数
          paramsData: this.paramsData,
        },
      })
    },
    bb(i) {
      this.paramsData.names = i
      this.$router.push({
        name: 'applist',
        params: {
          //params 传递参数
          paramsData: this.paramsData,
        },
      })
    },
    bbb(i) {
      this.$router.push({
        name: 'applistdetails',
        params: {
          //params 传递参数
          ids: i,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.market {
  .marketBar {
    background-color: #fff;
  }
  .soo {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;
    .sooTitle {
      flex: 1;
      h2 {
        font-size: 32px;
      }
    }
    .sooInput {
      flex: 1;
    }
    .aLink {
      flex: 1;
      margin-left: 20px;
    }
  }
}
.marketNav {
  height: 386px;
  background: url('../assets/images/u8.png') no-repeat;
  background-size: cover;
  margin-bottom: 80px;
  .marketContent {
    display: flex;
    .marketBg {
      flex: 1;
      max-width: 320px;
      height: 386px;
      position: relative;
      img {
        position: absolute;
      }
      .img1 {
        left: 0;
        top: -34px;
        width: 320px;
        height: 454px;
      }
      .img2 {
        right: -27px;
        top: -34px;
        width: 28px;
        height: 36px;
      }
      .img3 {
        right: -27px;
        bottom: -34px;
        width: 28px;
        height: 36px;
      }
      .marTitle {
        position: absolute;
        top: 0;
        left: 0;

        .marspan {
          color: #fff;
          width: 320px;
          line-height: 55px;
          font-weight: 700;
          font-size: 16px;
          text-align: center;
          background-color: rgba(53, 115, 198, 1);
        }
        .marspan:hover {
          color: rgba(53, 115, 198, 1);
          background-color: #fff;
        }
      }
      .marCon {
        position: absolute;
        right: -910px;
        top: 25px;
        width: 910px;
        height: 336px;
        background-color: #fff;
        padding: 20px;
        box-sizing: border-box;
        z-index: 999;
        .marLink {
          display: inline-block;
          margin: 0 10px;
          cursor: pointer;
        }
        .marLink:hover {
          color: #0078d7;
        }
      }
    }
  }
  .marLun {
    flex: 2;
    max-width: 900px;
    margin-left: 10px;
    height: 336px;
    width: 900px;
    margin-top: 25px;
    img {
      width: 900px;
      height: 336px;
    }
  }
}
.hot {
  background: url('../assets/images/u1872.png') no-repeat;
  background-size: cover;
  padding-top: 20px;
  margin-bottom: 10px;
  padding-bottom: 20px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #fff;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .hotCon {
    display: flex;
    .hotConItem {
      flex: 1;
      margin: 0 5px;

      position: relative;
      .oneItem {
        min-height: 448px;
        border-radius: 4px;
        background-color: #fff;
        h4 {
          text-align: center;
          font-weight: 700;
          font-size: 16px;
          margin: 0;
          padding: 20px 0;
          box-sizing: border-box;
        }
        p {
          padding: 0 20px;
          line-height: 20px;
          .a {
            float: left;
            font-weight: 700;
            font-size: 16px;
            color: #d9001b;
          }
          .b {
            float: right;
            font-weight: 700;
            font-size: 16px;
            color: #f59a23;
          }
        }
        .bb {
          height: 86px;
        }
        .aa {
          height: 26px;
        }

        .imgTwo {
          position: absolute;
          bottom: 0;
          text-align: center;
          padding: 0 20px;
          width: 100%;
          box-sizing: border-box;

          img {
            width: 100%;
            height: 100%;
            max-width: 230px;
            max-height: 230px;
            padding-bottom: 10px;
          }
        }
      }
    }
    .itemss {
      flex: 1.5;
      margin: 0 5px;

      .TwoItem {
        display: flex;
        min-height: 214px;
        margin: 0 0 5px 0;
        background-color: #fff;
        border-radius: 4px;
        h4 {
          text-align: center;
          font-weight: 700;
          font-size: 16px;
        }
        .textTwo {
          position: relative;
          .aa {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 86%;
          }
        }
        p {
          padding: 0 20px;
          line-height: 20px;
          .a {
            float: left;
            font-weight: 700;
            font-size: 16px;
            color: #d9001b;
          }
          .b {
            float: right;
            font-weight: 700;
            font-size: 16px;
            color: #f59a23;
          }
        }
        .imgTwo {
          flex: 1;

          img {
            width: 100%;
            height: 100%;
            max-width: 195px;
            max-height: 246px;
            padding: 10px;
            box-sizing: border-box;
          }
        }
        .textTwo {
          flex: 1.5;
        }
      }
      .TwoItem:last-child {
        margin-bottom: 0;
      }
    }
  }
}
.classify {
  background-color: #fff;
  padding-top: 20px;
  margin-bottom: 10px;
  padding-bottom: 20px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .classifyCon {
    display: flex;
    flex-wrap: wrap;
    .classifyItem {
      flex: 1 1 50%;
      margin-bottom: 20px;
      display: flex;
      .classifyItem-nav {
        position: relative;
        flex: 1;
        min-height: 537px;
        background-color: rgba(72, 148, 247, 0.886274509803922);
        text-align: center;
        .h4 {
          font-weight: 700;
          font-style: normal;
          font-size: 16px;
          color: #fff;
          margin: 20px 0;
        }
        .ulist {
          .ulist-name {
            display: block;
            width: 140px;
            height: 40px;
            line-height: 40px;
            font-weight: 700;
            color: #fff;
            text-align: center;
            border: 1px solid #fff;
            box-sizing: border-box;
            margin: 0 auto 10px auto;
            cursor: pointer;
          }
          .ulist-name:hover {
            display: block;
            width: 140px;
            height: 40px;
            line-height: 40px;
            font-weight: 700;
            color: #0078d7;
            text-align: center;
            background-color: #fff;
            border: 1px solid #fff;
            box-sizing: border-box;
            margin: 0 auto 10px auto;
          }
          .act {
            display: block;
            width: 140px;
            height: 40px;
            line-height: 40px;
            font-weight: 700;
            color: #0078d7;
            text-align: center;
            background-color: #fff;
            border: 1px solid #fff;
            box-sizing: border-box;
            margin: 0 auto 10px auto;
          }
        }
        .el-link {
          position: absolute;
          bottom: 10px;
          left: 0;
          width: 100%;
          font-size: 16px;
          font-weight: 700;
          color: #fff;
        }
      }
      .classifyItem-list {
        flex: 2.5;
        display: flex;
        flex-wrap: wrap;
        .listItem {
          flex: 1 1 50%;
          border-top: 1px solid rgba(215, 215, 215, 1);
          border-right: 1px solid rgba(215, 215, 215, 1);
          box-sizing: border-box;
          .title {
            font-weight: 700;
            font-size: 16px;
            margin: 20px 0 30px 0;
            text-align: center;
          }
          p {
            padding: 0 30px;
            height: 70px;
          }
          strong {
            display: block;
            font-weight: 700;
            font-size: 17px;
            color: #d9001b;
            text-align: center;
            margin: 30px 0;
          }
          .span {
            display: block;
            text-align: center;
            margin-bottom: 20px;
            span {
              font-weight: 700;
              font-size: 16px;
              color: #f59a23;
            }
          }
        }
        .listItem:nth-last-child(2) {
          border-bottom: 1px solid rgba(215, 215, 215, 1);
        }
        .listItem:last-child {
          border-bottom: 1px solid rgba(215, 215, 215, 1);
        }
      }
    }
    .classifyItem:nth-child(2) {
      .classifyItem-nav {
        background-color: rgba(119, 91, 249, 0.886274509803922);
      }
    }
    .classifyItem:nth-child(3) {
      .classifyItem-nav {
        background-color: rgba(3, 121, 211, 1);
      }
    }
    .classifyItem:last-child {
      .classifyItem-nav {
        background-color: rgba(119, 91, 249, 1);
      }
    }
  }
}
.footerList {
  width: 100%;
  img {
    width: 100%;
  }
}
</style>
